import './about-timeline.scss';
import type { AboutTimelineItem } from '../../../interfaces/about';

interface AboutTimelineProps {
  items: AboutTimelineItem[];
}

export function AboutTimeline({ items }: AboutTimelineProps) {
  return (

    <section className="section-container timeline-container">
           <div className='timeline-block desktop-only'></div>
    <div className="timeline-content" >
 
        <div className="timeline-line" style={{"--items": items.length} as React.CSSProperties}>
        <div className='timeline-block-mobile'></div>
            {
                items.map((item,index)=>{
                
                    return <div className="timeline-item" key={index}>
                      <div className='timeline-card'>
                        <p className="timeline-card-date">{item.date}</p>
                        <p className="timeline-card-title">{item.title}</p>
                        <p className="timeline-card-description">
                          <small>{item.description}</small>
                        </p>
                        </div>
                    </div>

                })
            }
        </div>
    </div>
    </section>
  );
}
